/**
 * @author gyb(mocheer)
 * @since 2016.11.4
 * 台风图元
 */
import lonlats from '../utils/LonLats';
import Quadrant from '../feature/Quadrant';
import Popup from '../polyfill/Popup';
import VectorMarker from './VectorMarker'
let {
  marker: toMarker,
  canvas: toCanvas,
  polyline: toPolyline,
  circle: toCircle,
  circleMarker,
  divIcon: toDivIcon,
  tooltip: toTooltip,
  featureGroup: toFeatureGroup,
  latLng: toLatLng
} = L;
let {
  assign: $assign
} = T;

// svg[Attributes]{
//   stroke - linejoin: round;
//   stroke - linecap: round;
//   pointer - events: none;
//   stroke: rgb(0, 150, 255);
//   stroke - opacity: 0.8;
//   stroke - width: 3;
//   fill: none;
// }

/**
 * 台风图元
 * @class Typhoon
 * todo: 用 FeatureGroup 重构
 */
export default class Typhoon {
  /**
   * 配置信息
   */
  options = {
    // 自动播放
    autoPlay: true,
    // 是否绘制台风路径
    hasLsljLater: true,
    // 确保台风在视野范围内
    inView: true,
    // 当inview=true且keepZoom=true,确保视野范围的时候不缩放地图
    keepZoom: true,
    // 点击是否根据路径点重新绘制台风
    click2drawOnTime: true,
    // 是否对路径点进行碰撞检测、抽稀
    hitForPoint: true,
    // 历史路径
    ls: {
      color: '#0096FF',
      weight: 3,
      opacity: .8,
      interactive: false
    },
    // 历史路径-灰色
    lsyb: {
      color: '#666666',
      weight: 2,
      opacity: .8,
      interactive: false
    },
    // 预报机构,预报路径点
    org: {
      weight: 1,
      dashArray: '10,3',
      interactive: false
    },
    orgs: [{
        label: "中国",
        th: "CN",
        color: "#FF4050"
      },
      {
        label: "韩国",
        th: "KR",
        color: "#000000"
      },
      {
        label: "美国",
        th: "US",
        color: "#4099EE"
      },
      {
        label: "中国台湾",
        th: "TW",
        color: "#FFA040"
      },
      {
        label: "日本",
        th: "JP",
        color: "#43FF4B"
      },
      {
        label: "中国香港",
        th: "HK",
        color: "#FF40F5"
      }
    ],
    // 台风等级
    grade: {
      color: '#000',
      radius: 4,
      fillColor: '#FFF',
      weight: 1,
      fillOpacity: 1,
      src: 'circle'
    },
    grades: [{
        F1: 0,
        F2: 0.2
      },
      {
        F1: 0.3,
        F2: 1.5
      },
      {
        F1: 1.6,
        F2: 3.3
      },
      {
        F1: 3.4,
        F2: 5.4
      },
      {
        F1: 5.5,
        F2: 7.9
      },
      {
        F1: 8,
        F2: 10.7
      },
      {
        F1: 10.8,
        F2: 13.8,
        fillColor: '#00FF03',
        GRADENAME: '热带低压'
      },
      {
        F1: 13.95,
        F2: 17.15,
        fillColor: '#00FF03',
        GRADENAME: '热带低压'
      },
      {
        F1: 17.2,
        F2: 20.7,
        fillColor: '#0062FE',
        GRADENAME: '热带风暴'
      },
      {
        F1: 20.8,
        F2: 24.4,
        fillColor: '#0062FE',
        GRADENAME: '热带风暴'
      },
      {
        F1: 24.5,
        F2: 28.4,
        fillColor: '#FDFA00',
        GRADENAME: '强热带风暴'
      },
      {
        F1: 28.5,
        F2: 32.6,
        fillColor: '#FDFA00',
        GRADENAME: '强热带风暴'
      },
      {
        F1: 32.7,
        F2: 36.9,
        fillColor: '#FDAC03',
        GRADENAME: '台风'
      },
      {
        F1: 37,
        F2: 41.4,
        fillColor: '#FDAC03',
        GRADENAME: '台风'
      },
      {
        F1: 41.5,
        F2: 46.1,
        fillColor: '#F072F6',
        GRADENAME: '强台风'
      },
      {
        F1: 46.2,
        F2: 50.9,
        fillColor: '#F072F6',
        GRADENAME: '强台风'
      },
      {
        F1: 51,
        F2: 56,
        fillColor: '#FD0002',
        GRADENAME: '超强台风'
      },
      {
        F1: 56.1,
        F2: 161.2,
        fillColor: '#FD0002',
        GRADENAME: '超强台风'
      }
    ],
    // 台风风圈
    c7: {
      fillColor: '#79C0AE',
      fillOpacity: 0.5,
      color: '#49BA6E',
      weight: 1
    },
    c10: {
      fillColor: '#FFFF00',
      fillOpacity: 0.2,
      color: '#FFFF00',
      weight: 1
    },
    c12: {
      fillColor: '#FF0000',
      fillOpacity: 0.3,
      color: '#FF0000',
      weight: 1
    },
    // 台风登陆地
    land: {
      src: T + 'assets/common/dmap/markers/flag.png',
    }
    // 台风风眼
    // hurricane: {iconUrl: T + "assets/common/dmap/markers/typhoonIco.gif",iconSize: [32, 32]}
    // 
  }
  // 
  group = toFeatureGroup();
  //
  /**
   * 
   * @param {*} data 
   * @param {*} style 
   */
  constructor(data, options) {
    this.data = T.action(data);
    options = $assign(this.options, options);
    options.grades = options.grades.map(val => $assign({}, options.grade, val));
    //
    this._points = [];
  }
  /**
   * 动态改变预报机构集合。
   * @param {*} options 
   */
  setOptions(options) {
    $assign(this.options, options);
    this.update();
  }
  /**
   * 更新重绘
   */
  update(data) {
    if (data && data !== this.data) { //最新台风实时数据刷新
      this.data = T.action(data);
      this.ci = data.points.length - 1;
    }
    if (this.complete) {
      this.draw(this.ci);
    }
  }
  /**
   * 创建路径点 
   * @param coor
   * @param options
   * @param data
   */
  createPoint(coor, options, data) {
    let marker = circleMarker(lonlats(coor), options);
    data._source = this.data;
    marker.__data = data;
    // 创建弹出层
    if (options = this.options.popup) {
      marker.bindPopup(new Popup(options), options);
    }
    return marker;
  }
  /**
   * 创建登录地
   */
  createLand(coor, options) {
    return new VectorMarker(lonlats(coor), options);
  }
  /**
   * 创建路径线
   * @param coor
   * @param options
   */
  createPolyline(coor, options) {
    return toPolyline(lonlats(coor, 1), options);
  }
  /**
   * 创建风圈
   * @param center
   * @param radius
   * @param options
   */
  createCicle(center, radius, options) {
    return radius && toCircle(lonlats(center), radius * 1000, options);
  }
  /**
   * 绘制四象风圈
   * { ne, nw, sw, se}-> [ne, nw, sw, se]
   * @param center
   * @param radius
   * @param style
   */
  createQuadrant(center, radius, style) {
    if (!radius) return;
    let {
      ne,
      nw,
      sw,
      se
    } = radius;
    if (!ne || !nw || !sw || !se) {
      return;
    }
    this.renderer = this.renderer || toCanvas({
      style: {
        zIndex: 40
      }
    });
    return new Quadrant([center[1], center[0]], $assign({}, style, {
      renderer: this.renderer,
      radius: [ne * 1000, nw * 1000, sw * 1000, se * 1000]
    }))
  }
  /**
   * 绘制飓风动画
   * @param center
   * @param options
   */
  createHurricane(center, options, grade) {
    let colorIndex = parseInt((grade - 6) / 2) + 1;
    return options ? toMarker(lonlats(center), {
      icon: toDivIcon(options)
    }) : new VectorMarker(lonlats(center), {
      src: T + `assets/common/dmap/typhoon/hurricane${colorIndex > 0 ? colorIndex : 0}.png`,
      rotate: true
    })
  }
  /**
   * draw
   * {points}
   * {radius7,radius10,radius12,radius7_quad,radius10_quad,radius12_quad}-> {r7,r10,r12,r7_q,r10_q,r12_q}
   * {lng,lat} -> {lon,lat}
   * {power,strong} 台风等级,台风等级对应名称
   * {sets,points} 预报机构,预报路径
   * @param time
   * @property _points 缓存当前历史路径绘制的点图元
   */
  draw(time) {
    let that = this;
    let {
      options,
      data,
      group,
      lsp,
      createPolyline,
      createCicle,
      _points
    } = that;
    let {
      autoPlay,
      ls,
      lsyb,
      grades,
      c7,
      c10,
      c12,
      org,
      orgs,
      hurricane,
      hasLsljLater,
      hitForPoint
    } = options;
    let createPoint = that.createPoint.bind(that);
    let createLand = that.createLand.bind(that);
    let createQuadrant = that.createQuadrant.bind(that);
    let handleEvent = that.handleEvent.bind(that);
    let {
      points,
      land
    } = data;
    let ci = this.getTimeIndex(points, time); //当前台风时间点，默认为台风消亡时间点
    let len = points.length;
    let addLayer = (value, index, array) => {
      if (!value || (array === lsp && index > ci && autoPlay)) return;
      group.addLayer(value);
    }
    let getDistance = (p1, p2) => Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
    if (!that.tempLayer) {
      that.tempLayer = toFeatureGroup();
      group.addLayer(that.tempLayer);
    }
    let {
      tempLayer
    } = that;
    let addTempLayer = (value, index, array) => {
      if (!value || (array === lsp && index > ci && autoPlay)) return;
      tempLayer.addLayer(value);
    }
    //
    let drawing = (i, prev) => {
      // 清除，点不能清除，因可能在播放过程显示Popup
      tempLayer.clearLayers();
      if (!i || i < prev) {
        group.clearLayers();
        group.addLayer(tempLayer);
      }
      // 声明
      let lslj; // 历史路径
      let lslj_yb; // 历史路径-灰色
      let yblj = []; // 预报路径
      let tffq = []; // 台风风圈
      let landPoints = []; // 台风登陆地
      // 
      let item = points[i];
      //
      let lslj_prev = points.slice(0, i + 1);
      let lslj_after = points.slice(i);
      let coor = [item.lng, item.lat];
      // 绘制"当前"历史路径
      if (lslj_prev.length > 1) {
        lslj = createPolyline(lslj_prev, ls);
      }
      // 绘制"未来"历史路径-灰色
      if (!autoPlay && hasLsljLater && lslj_after.length > 1) {
        lslj_yb = createPolyline(lslj_after, lsyb);
        lslj_prev = lslj_prev.concat(lslj_after.slice(1));
      }
      //
      lsp.length = lslj_prev.length;
      // 遍历历史路径点
      lslj_prev.forEach((item, i) => {
        // 抽稀
        if (hitForPoint) {
          // 获取当前路径点的像素坐标
          let point = item._point = this.map.latLngToLayerPoint(toLatLng(item));
          // 获取上个路径点的像素坐标
          let point_prev = (i => {
            while (i--) {
              if (lsp[i]) return lslj_prev[i]._point;
            }
          })(i);
          if (i > 0 && getDistance(point, point_prev) < 8) {
            lsp[i] = null;
            return;
          }
        }
        // 
        let marker = lsp[i] = _points[i] = _points[i] || createPoint([item.lng, item.lat], grades[item.power || 0], item).on('click mouseover mouseout', handleEvent)
        if (i === 0 && !marker.getTooltip()) {
          let tooltip = toTooltip(T.assign({
            zoom: 1,
            direction: 'right',
            offset: [5, 0],
          }, this.options.tooltip), marker).setContent(data.tfbh + data.name);
          marker.bindTooltip(tooltip);
        }
      })
      // 登录地
      landPoints = options.land && (land || []).map(data => {
        let tm = T.clock(data.land_time);
        let ctm = T.clock(item.time);
        if (tm.date < ctm.date) {
          let marker = createLand(data, options.land)
          return marker;
        }
      })

      // 绘制风圈和预报路径
      if (autoPlay || i === ci) { //
        let {
          radius7_quad,
          radius10_quad,
          radius12_quad,
          forecast
        } = item;
        // 绘制飓风动画和风圈
        let h = that.createHurricane(coor, hurricane, item.power);
        let r7 = createQuadrant(coor, radius7_quad, c7) || createCicle(coor, item.radius7, c7);
        let r10 = createQuadrant(coor, radius10_quad, c10) || createCicle(coor, item.radius10, c10);
        let r12 = createQuadrant(coor, radius12_quad, c12) || createCicle(coor, item.radius12, c12);
        tffq.push(r7, r10, r12, h);
        // 绘制预报路径：回溯 
        if (!autoPlay || i === len - 1) {
          let _points = [];
          orgs.forEach(data => {
            let sets = data.label; //预报机构名称
            let index = i;
            let item;
            let point;
            let search = {
              sets: sets
            };
            while (!item && index >= 0) {
              point = points[index--];
              forecast = point.forecast;
              item = forecast && T.find(forecast, search);
            }
            if (item) {
              let {
                sets,
                points
              } = item;
              let style = $assign({}, org, T.find(orgs, {
                label: sets
              }));
              yblj.push(createPolyline([point].concat(points), style));
              //
              points.forEach((item) => {
                item.sets = sets; // 用于显示信息窗
                // 抽稀
                let point = item._point = this.map.latLngToLayerPoint(toLatLng(item));
                if (hitForPoint) {
                  for (let j = 0, len = _points.length; j < len; j++) {
                    if (getDistance(point, _points[j]) < 8) {
                      return;
                    }
                  }
                }
                _points.push(point);
                //
                yblj.push(createPoint(item, grades[item.power || 0], item).on('click mouseover mouseout', handleEvent))
                //
              })
            }
          })
        }
      }
      //
      tffq.forEach(addTempLayer);
      yblj.forEach(addTempLayer);
      addTempLayer(lslj);
      addTempLayer(lslj_yb);
      lsp.forEach(addLayer);
      landPoints.forEach(addTempLayer);
      tempLayer.bringToBack();
    }

    if (autoPlay) {
      let i = 0;
      let playing = () => {
        //init 防止播放过程中就被移除
        if (this.init) {
          if (i < len && that.layer) {
            drawing(i, i - 1);
            setTimeout(playing, 30);
            i++;
          } else if (that.layer) {
            T.do('typhoon-playend', {
              tf: data,
              attr: points[i - 1]
            })
            options.autoPlay = false;
            that.complete = true;
          }
          // 
          if ((i === len) && options.inView && !this.layer.suspended) {
            (this.map && options.keepZoom) ? this.map.setView(points[i - 1]): this.map.fitBounds(toPolyline([
              [30, 105],
              [10, 125]
            ].concat(points)).getBounds());
          }
        }
      }
      playing();
    } else {
      drawing(ci, that.ci);
      T.do('typhoon-playend', {
        tf: data,
        attr: points[ci]
      })
      that.complete = true;
    }
    that.ci = ci;
  }

  /**
   * 获取台风播放时间点
   * @param data 
   * @param time 
   */
  getTimeIndex(data, time) {
    if (time !== void 0) {
      return +time;
    }
    return data.length - 1;
  }
  /**
   * 设置台风播放时间点
   * @param time
   */
  setTimeIndex(time) {
    if (this.ci !== time) {
      if (this.complete) {
        // 用于二三维一体化，同步台风历史路径
        this.data.do('setTimeIndex', time)
        this.draw(time);
      }
    }
  }
  /**
   * 
   * @param layer 
   */
  addTo(layer) {
    let that = this;
    if (layer.map) {
      that.map = layer.map.on('zoomend', () => {
        that.init && that.update()
      });
      that.layer = layer;
      layer._add(this.group);
      if (!that.init) {
        that.init = true;
        that.lsp = [];
        that.draw();
      }
    } else {
      // 未加载到地图上 
      layer.layer.on('add', () => {
        this.addTo(layer);
      })
    }
  }
  /**
   * 移除
   */
  remove() {
    this.init = false;
    // 不能直接用 remove，当上层layer被挂起移除的时候无法删除。
    // 所以这里用 removeFrom
    this.layer && this.group.removeFrom(this.layer.layer);
  }
  /**
   * 台风路径点点击/移入事件
   * @param e
   */
  handleEvent(e) {
    let {
      data,
      lsp,
      complete,
      _overTarget,
      options
    } = this;
    let {
      target,
      type
    } = e;
    let i = lsp.indexOf(target);
    if (!complete) {
      return;
    }
    let event;
    switch (type) {
      case 'click':
        event = {
          data: data,
          dataProvider: data.points,
          selItem: data.points[i],
          event: e
        };
        if (lsp[i]) {
          options.click2drawOnTime && this.setTimeIndex(i);
          target.openPopup();
          target.setRadius(7);
          T.do('typhoon-lslj-click', event);
          //台风播放控件
        } else {
          target.openPopup();
          T.do('typhoon-yblj-click', event);
        }
        break;
      case 'mouseover':
        event = {
          tf: data,
          attr: target.__data || data.points[i],
          event: e
        };
        if (lsp[i]) {
          if (_overTarget != target) {
            target.setRadius(7);
            this._overTarget = target;
          }
          T.do('typhoon-lslj-over', event);
        } else {
          T.do('typhoon-yblj-over', event);
        }
        break;
      case 'mouseout':
        if (_overTarget) {
          _overTarget.setRadius(4);
          this._overTarget = null;
        }
        T.do('typhoon-lslj-out', event);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/feature/Typhoon.js